import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import QueryAPI from '../util/QueryAPI';
import TokenStore from '../stores/TokenStore';
import CrossChannelAPI from '../util/CrossChannelAPI';

const CrossChannelActions = {
  saveScenario(organizationId, configs) {
    const token = TokenStore.getToken();
    return new CrossChannelAPI(token).scenarios
      .createScenario(organizationId, configs)
      .then((response) => {
        AppDispatcher.dispatch({
          actionType: Constants.CrossChannel.SCENARIO_SAVED,
          organizationId,
          configs,
        });
        return response;
      });
  },

  cloneScenario(organizationId, configs) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.SCENARIO_CLONED,
      organizationId,
      configs,
    });
  },

  loadScenarios() {
    new CrossChannelAPI(TokenStore.getToken()).scenarios.getScenarios().then((response) => {
      const runs = (response.included || []).filter(e => e.type === 'runs');
      AppDispatcher.dispatch({
        actionType: Constants.CrossChannel.SCENARIOS_RECEIVED,
        scenarios: response.data,
        runs,
      });
    });
  },

  pollForScenarios() {
    CrossChannelActions.loadScenarios();
    const interval = setInterval(() => {
      CrossChannelActions.loadScenarios();
    }, 10000);
    return () => { clearInterval(interval); };
  },

  loadSourceTables() {
    new QueryAPI(TokenStore.getToken()).queries.getQueries().then((response) => {
      AppDispatcher.dispatch({
        actionType: Constants.CrossChannel.SOURCE_TABLES_RECEIVED,
        queries: response.queries,
      });
    });
  },

  // The API is not currently rigged up for this, so just reload scenarios until it is
  // loadRuns() {
  //   new CrossChannelAPI(TokenStore.getToken()).scenarios.getRuns().then((response) => {
  //     AppDispatcher.dispatch({
  //       actionType: Constants.CrossChannel.RUNS_RECEIVED,
  //       runs: response.data,
  //     });
  //   });
  // },

  runSavedScenario(savedScenarioId) {
    const token = TokenStore.getToken();
    return new CrossChannelAPI(token).scenarios
      .runSavedScenario(savedScenarioId)
      .then((response) => {
        AppDispatcher.dispatch({
          actionType: Constants.CrossChannel.RUN_SUBMITTED,
          runs: response.data,
        });
        return response;
      });
  },

  destroyScenario(savedScenarioId) {
    const token = TokenStore.getToken();
    return new CrossChannelAPI(token).scenarios
      .destroyScenario(savedScenarioId)
      .then((response) => {
        AppDispatcher.dispatch({
          actionType: Constants.CrossChannel.SCENARIO_DESTROYED,
          scenarioId: savedScenarioId,
        });
        return response;
      });
  },

  toggleAdvanced() {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.TOGGLE_ADVANCED,
    });
  },

  updateValue(organizationId, key, newValue) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.UPDATE_REQUESTED,
      organizationId,
      key,
      newValue,
    });
  },

  addValue(organizationId, key, addValue) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.ADDVALUE_REQUESTED,
      organizationId,
      key,
      addValue,
    });
  },

  removeValue(organizationId, key, removeValue) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.REMOVEVALUE_REQUESTED,
      organizationId,
      key,
      removeValue,
    });
  },

  updateMap(organizationId, map, key, value) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.UPDATE_MAP,
      organizationId,
      map,
      key,
      value,
    });
  },

  updateMode(organizationId, mode, attribute, value) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.UPDATE_MODE,
      organizationId,
      mode,
      attribute,
      value,
    });
  },

  reset(organizationId) {
    AppDispatcher.dispatch({
      actionType: Constants.CrossChannel.RESET_REQUESTED,
      organizationId,
    });
  },
};

// CrossChannelActions.debouncedLoadScenarios = debounce(CrossChannelActions.loadScenarios, 1000);
// CrossChannelActions.debouncedLoadRuns = debounce(CrossChannelActions.loadRuns, 1000);

export default CrossChannelActions;
